/**
 * Export slider types.
 *
 * @author    Naotoshi Fujita
 * @copyright Naotoshi Fujita. All rights reserved.
 */

/**
 * Normal slider.
 *
 * @type {string}
 */
export const SLIDE = 'slide';

/**
 * Loop after the last slide and before the first one.
 *
 * @type {string}
 */
export const LOOP = 'loop';

/**
 * The track doesn't move.
 *
 * @type {string}
 */
export const FADE = 'fade';